import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';
import { VacancyPatternStatusesEnum } from '@thinknet-gmbh/platform-common';

export const VACANCIES_STATUS_STYLES = {
  [VacancyPatternStatusesEnum.PUBLISHED]: {
    background: PLATFORM_THEME_COLORS.tone.lightGreen,
    fontColor: PLATFORM_THEME_COLORS.tone.green,
  },
  [VacancyPatternStatusesEnum.CLOSED]: {
    background: PLATFORM_THEME_COLORS.tone.lightRed,
    fontColor: PLATFORM_THEME_COLORS.tone.red,
  },
  [VacancyPatternStatusesEnum.DRAFT]: {
    background: PLATFORM_THEME_COLORS.tone.lightYellow,
    fontColor: PLATFORM_THEME_COLORS.tone.yellow,
  },
};
